// @ts-nocheck
import { LocalStorage } from '@hoa/config';

export const getQueryVariable = (variable: any, search = '') => {
  const query = search.substring(1);
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i += 1) {
    const pair = vars[i].split('=');
    if (decodeURIComponent(pair[0]) === variable) {
      return decodeURIComponent(pair[1]);
    }
  }

  return null;
};

export const saveMarketingData = () => {
  const utmParameters = {
    utmSource: getQueryVariable('utm_source', window.location.search),
    utmCampaign: getQueryVariable('utm_campaign', window.location.search),
    utmMedium: getQueryVariable('utm_medium', window.location.search),
    utmPage: getQueryVariable('utm_page', window.location.search),
  };

  //Disabled since utmsource 'organic' was not correct
  // if (!sessionStorage.getItem(LocalStorage.UTM_PARAMETERS)) {
  //   utmParameters.utmSource =
  //     !utmParameters.utmSource &&
  //     document &&
  //     document.referrer &&
  //     document.referrer.includes('google')
  //       ? 'organic'
  //       : utmParameters.utmSource;
  // }

  if (utmParameters.utmSource) {
    sessionStorage.setItem(
      LocalStorage.UTM_PARAMETERS,
      JSON.stringify(utmParameters),
    );
  }

  if (
    sessionStorage.getItem(LocalStorage.GCLID_PARAMETERS) === null &&
    getQueryVariable('gclid', window.location.search) !== null
  ) {
    sessionStorage.setItem(
      LocalStorage.GCLID_PARAMETERS,
      getQueryVariable('gclid', window.location.search),
    );
  }
};
